import React, {PureComponent} from 'react';
import {Field, reduxForm} from 'redux-form'
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

import Input from '../../Form/Field/Input.jsx';
import NakedInput from '../../Form/Field/Naked.jsx';
import validate from './validate.js';
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';
import conf from '../../../../shared/conf.js';
import AccountTypeSelector from './AccountTypeSelector/AccountTypeSelector.jsx';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';
import {generate} from '../../../routes.js';

import './ConfirmRegistrationForm.scss';

export const name = 'ConfirmRegistrationForm';

class ConfirmRegistrationForm extends PureComponent {
  static propTypes = {
    currentUniverseId: PropTypes.number,
    universes: PropTypes.array.isRequired,
  };

  static defaultProps = {
    currentUniverseId: null
  }

  constructor(props) {
    super(props);
    props.initialize({
      main_universe: props.currentUniverseId ? props.currentUniverseId.toString() : null,
    });

    this.state = {
      accountType: conf.accountTypes.freelance
    }
  }

  onAccountTypeChange = (accountType) => {
    this.props.change('account_type', accountType);
    this.setState({accountType: accountType});
  };

  render() {
    return (
      <div id={name} className="confirm-registration-form text-center">
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <FormGlobalErrors errors={this.props.error}/>
          <div className="row">
            <div className="col-md-6 offset-md-3 col-xs-12">
              <Field
                name="account_type"
                type="hidden"
                component={NakedInput}/>
              <div>
                <AccountTypeSelector
                  onChange={this.onAccountTypeChange}
                  value={this.state.accountType}/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-6 offset-md-3 col-xs-12">
              <label>Univers*</label>
              <div className="universes-radio d-flex" id="universes">
                {this.props.universes.map((universe, index) => (
                  <Field
                    key={universe.id}
                    id={`${name}.universe${index}`}
                    label={universe.name}
                    name="main_universe"
                    type="radio"
                    value={universe.id.toString()}
                    component={Input}
                    errorTarget="universes"
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 offset-md-3 col-xs-12">
              <Field
                label={`Numéro de téléphone*${this.state.accountType === conf.accountTypes.freelance ? '*' : ''}`}
                name="tel"
                placeholder="+15142565657"
                component={Input}
                type="tel"/>
            </div>
          </div>
          {this.state.accountType === conf.accountTypes.freelance &&
            <div className="row">
              <div className="col-md-6 offset-md-3 col-xs-12 phone-req-explanation">
                **Cela vous permettra de recevoir des rappels de rendez-vous et les offres de mandats par SMS.
              </div>
            </div>
          }
          <div className="row">
            <div className="col-md-6 offset-md-3 col-xs-12">
              <Field
                label={
                  <span>
                    J'accepte <Link to={generate({name: 'cgu'})} target="_blank" rel="noopener noreferrer">
                    les conditions d'utilisation</Link> du site
                  </span>
                }
                name="cgu_accepted"
                component={Input}
                type="checkbox"/>
            </div>
          </div>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
      </div>
    );
  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name, false),
  validate
})(ConfirmRegistrationForm);